import { render } from "./CardButton.vue?vue&type=template&id=22b2cf50&scoped=true"
import script from "./CardButton.vue?vue&type=script&lang=js"
export * from "./CardButton.vue?vue&type=script&lang=js"

import "./CardButton.vue?vue&type=style&index=0&id=22b2cf50&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22b2cf50"]])

export default __exports__